import { EntityTypeEnum } from "../constant/enum";
import { NAVIGATION_PATHS } from "./navigation/constants";

/**
 * Investor portal access by user type.
 *
 *   | User type                                  | Landing page         |
 *   | ------------------------------------------ | -------------------- |
 *   | Individual Investor                        | Offer Room           |
 *   | Corporate Investor Authorised Rep          | Offer Room           |
 *   | Corporate Investor Admin / Director (no AR)| Investment Portfolio |
 *
 * Corporate users without the Authorised Representative role may only use
 * Investment Portfolio, Transaction History and Onboarding Doc. Offer Room,
 * Withdrawal and Risk Disclosure are for the AR (and individual investors,
 * who act for themselves).
 *
 * Fail-closed: anything other than an individual or a confirmed AR
 * (`isAuthRep` `null` / `undefined` included) gets the restricted portal. The
 * restricted set is a subset of the full one, so a wrong "no" costs the user a
 * page, where a wrong "yes" would open subscription to someone not authorised
 * to commit the company's money.
 */
export const hasFullInvestorAccess = (
  entityType: string | null | undefined,
  isAuthRep: boolean | null | undefined,
): boolean => entityType === EntityTypeEnum.INDIVIDUAL || isAuthRep === true;

/** Where an investor lands after login or account activation. */
export const getInvestorHomePath = (
  entityType: string | null | undefined,
  isAuthRep: boolean | null | undefined,
): string =>
  hasFullInvestorAccess(entityType, isAuthRep)
    ? NAVIGATION_PATHS.NOTE_OFFER_ROOM
    : NAVIGATION_PATHS.INVESTMENT_PORTFOLIO;
